import utils from '@/auth/utils'

export const ifAuthenticated = async (to, from, next) => {
    const isLoggedIn = await utils.isUserLoggedIn()
    // Redirect to login if not logged in
    if (!isLoggedIn) {
        const LOGIN_PAGE_NAME = 'auth-login'
        if (from.name !== LOGIN_PAGE_NAME) {
            return next({ name: LOGIN_PAGE_NAME })
        }
        return
    }

    const profileUserInfo = utils.getProfileUserInfo()
    const authUserInfo = utils.getUserInfo()
    if (profileUserInfo.userIdx || authUserInfo.userIdx !== profileUserInfo.userIdx) {
        await utils.refreshProfileUserInfo()
    }
    return next()
}

export const ifNotAuthenticated = (to, from, next) => {
    if (localStorage.getItem('x-auth-token')) {
        next('/')
    } else {
        next()
    }
}

export const signinWithEmailAndToken = async (to, from, next) => {
    const path = await utils.getRouteForUserFromService(to.params)
    next(path)
}

export const _ = undefined
